import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { catFormTipo } from 'src/app/utils';

@Component({
  selector: 'app-bitacora-pendiente',
  templateUrl: './bitacora-pendiente.component.html',
  styleUrls: ['./bitacora-pendiente.component.scss']
})
export class BitacoraPendienteComponent implements OnInit {

  fechaActual: any = moment().format('YYYY-MM-DD');
  showBitacoraCat: string = '';
  categoriaForm: FormGroup;

  bitacoraForm = new FormGroup({
    bitacoraTipo: new FormControl('', Validators.required)
  });

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
  }

  showBitadoraForm() {
    this.showBitacoraCat = this.bitacoraForm.value.bitacoraTipo;
    let setting = catFormTipo(this.showBitacoraCat, this.fechaActual);
    this.categoriaForm = this.formBuilder.group(setting);
    console.log( this.showBitacoraCat );
  }

  saveEvento() {
    if (!this.categoriaForm.valid) { return this.toastr.error(`Llene todos los campos para ${this.showBitacoraCat}`, 'Error', { positionClass: 'toast-bottom-right' } )}

    let tipo = this.showBitacoraCat.charAt(0).toUpperCase() + this.showBitacoraCat.slice(1);
    this.toastr.success(`${tipo} agregado correctamente`, 'Correcto', { positionClass: 'toast-bottom-right' } );

    console.log( 'data', this.categoriaForm.value );
  }

}
